import { getInjectedContent } from './injected-content';
import type { InitialState } from '../types/initial-state';
import { StateMetaTagName, StateSourceConfig, DataSource } from './state-config';

// Re-export for backwards compatibility
export {
  GlobalMetaTagName,
  StateMetaTagName,
  DynamicMetaTagName,
  DataSource,
  StateSourceConfig,
  InitialStateConfig,
} from './state-config';
export type { MetaTagName } from './state-config';

// FC-1410: Brand state loaded from /api/me API when feature flag enabled
StateSourceConfig[StateMetaTagName.Brand] = DataSource.API;

const stateToMetaTagNameMap: Record<keyof InitialState, StateMetaTagName> = {
  brand: StateMetaTagName.Brand,
  country: StateMetaTagName.Country,
  currenciesRates: StateMetaTagName.CurrenciesRates,
  currency: StateMetaTagName.Currency,
  retailer: StateMetaTagName.Retailer,
  stripe: StateMetaTagName.Stripe,
  user: StateMetaTagName.User,
  showRequestedInformationForm: StateMetaTagName.ShowRequestedInformationForm,
};

export function getInitialState(): InitialState {
  return Object.fromEntries(
    Object.entries(stateToMetaTagNameMap)
      .map(([key, tagName]) => [key, getInjectedContent(tagName)])
      .filter(([, value]) => value !== null && value !== undefined)
  );
}
